/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 渠道系列留资
 */
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel } from '../bases';
@BindAll()
export class AdvisoryProductController {
  Model = new BaseModel({ type: 'object' });

  /**职位下拉 */
  @computed
  get _DignityList() {
    return [
      {
        'label': '管理者',
        'value': '管理者',
      },
      {
        'label': '采购经理',
        'value': '采购经理',
      },
      {
        'label': 'IT管理员',
        'value': 'IT管理员',
      },
      {
        'label': '普通用户',
        'value': '普通用户',
      },
    ];
  }

  /**公司规模下拉 */
  @computed
  get _CompanySizeList() {
    return [
      {
        'label': '<50人',
        'value': '<50人',
      },
      {
        'label': '50-100人',
        'value': '50-100人',
      },
      {
        'label': '100-500人',
        'value': '100-500人',
      },
      {
        'label': '500-1000人',
        'value': '500-1000人',
      },
      {
        'label': '1000人以上',
        'value': '1000人以上',
      },
    ];
  }

  /** 产品与解决方案下拉 */
  @computed
  get _ProductOrProjectList() {
    return [
      {
        'label': '笔记本',
        'value': '笔记本',
      },
      {
        'label': '分体台式机/一体机',
        'value': '分体台式机/一体机',
      },
      {
        'label': '工作站',
        'value': '工作站',
      },
      {
        'label': '显示器',
        'value': '显示器',
      },
      {
        'label': '平板电脑',
        'value': '平板电脑',
      },
      {
        'label': '选件',
        'value': '选件',
      },
    ];
  }

  /** 省份下拉 */
  @computed
  get _ProvinceList() {
    return this.Model.get('_ProvinceList', []);
  }

  /** 城市下拉 */
  @computed
  get _CityList() {
    return this.Model.get('_CityList', []);
  }

  /** 行业下拉 */
  @computed
  get _IndustryList() {
    return this.Model.get('_IndustryList', []);
  }

  //获取省份下拉
  async getProviderList() {
    const res = await AjaxBasics.requestEnum(
      EnumAPI.product_advisory_province,
      { labelKey: 'NAME', valueKey: 'VALUE' },
    );
    this.Model.merge({ _ProvinceList: res || [] });
    return res;
  }

  //获取城市下拉
  async getCityList(province) {
    const res = await AjaxBasics.requestEnum(
      {
        ...EnumAPI.product_advisory_city,
        ...{ body: { province } },
      },
      { labelKey: 'NAME', valueKey: 'VALUE' },
    );
    this.Model.merge({ _CityList: res || [] });
    return res;
  }

  //获取行业下拉
  getIndustryList() {
    return AjaxBasics.requestEnum(EnumAPI.product_advisory_industry, {
      labelKey: 'name',
      valueKey: 'value',
    });
  }

  // 留资提交
  async submitAdvisory(body) {
    const res = await AjaxBasics.request({ ...EnumAPI.product_advisory, body });
  }
}
